<template>
    <div class="w-100 stock-form-container" id="outOfStockForm">
        <div class="w-100 text-left content-title">
            {{ modalText }}
        </div>
        <div class="w-100 content-text" v-html="outOfStockString"/>
        <form
            class="vue-form"
            :action="form.action"
            :method="form.method"
            novalidate
            @submit.prevent="submit"
        >
            <!--<span class="form-title"> {{ kStrings.kNOTIFY_ME_EMAIL }} </span> -->
            <input
                v-model="form.email"
                type="email"
                name="email"
                id="email"
                required="required"
                class="email"
                :disabled="isLoading"
                :class="{'error': showError, 'hasValue' : form.email}"
            />
                <label
                    for="email"
                    :class="{error: showError}"
                >
                    {{ kStrings.kEMAIL }}
                </label>
                <span v-show="showError" class="error-message">
                    {{ kStrings.kFIELD_EMAIL_FORM_ERROR }}
			    </span>
            <button type="submit" :disabled="!isValidEmail || isLoading">
                {{ kStrings.kNOTIFY_ME_SINGLE }}
            </button>
        </form>
        <MuffinLoader v-if="isLoading" />
    </div>
</template>

<script>
import request from '@/Utilities/httpRequest';
import {isEmpty} from 'lodash-es';
import MuffinLoader from '@/components/Muffin/Loader.vue';

import {storePdp} from '@/store/product-page';

const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
    storePdp,
    name: 'StockAlert',
    components: {
        MuffinLoader
    },
    props: {
        showLabel:true
    },
    data() {
        return {};
    },
    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        productStatus() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        form() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/stockAlertForm'];
        },
        isLoading() {
            return storePdp.getters['pdpDesktop/isLoading'];
        },
        outOfStockString() {
            if(!this.showLabel){
                return '';
            }
            let originalString = !isEmpty(this.form.variant.availableDate)
                ? this.kStrings.kNOTIFY_SIZE_STOCK_DATE
                : this.kStrings.kNOTIFY_SIZE_STOCK;
            if (!isEmpty(this.form.variant.label) && this.productStatus != 'CS') {
                originalString = originalString.replace('label_key', '<b>' +  this.form.variant.label + '</b>');
                originalString = originalString.replace('description_key', '<b>' + this.form.variant.description + '</b>');

                if (!isEmpty(this.form.variant.availableDate)) {
                    originalString = originalString.replace('date_key', '<b>' + this.form.variant.availableDate  + '</b>');
                }
            } else {
                if (this.productStatus == 'CS') {
                    originalString = this.kStrings.kCOMING_SOON_MESSAGE +
                        '\n' +
                        this.kStrings.kPROD_RECEIVE_MSG_MODAL;
                } else {
                    originalString =
                        this.kStrings.kSTOCK_ALERT +
                        '\n' +
                        this.kStrings.kPROD_RECEIVE_MSG_MODAL;
                }
                if (!isEmpty(this.form.variant.availableDate) && this.productStatus == 'CS') {
                    originalString = originalString + '\n' + this.kStrings.kNOTIFY_SIZE_STOCK_DATE_COMING_SOON;
                    originalString = originalString.replace('date_key', this.form.variant.availableDate);
                } else if (!isEmpty(this.form.variant.availableDate)) {
                    originalString = originalString + '\n' + this.kStrings.kNOTIFY_SIZE_STOCK_DATE_SINGLE;
                    originalString = originalString.replace('date_key', this.form.variant.availableDate);
                }

            }

            return originalString;
        },
        modalText: function () {
            if (this.productStatus !== undefined && this.productStatus == 'CS') {
                return this.kStrings.kNOTIFY_ME_COMING_SOON;
            }
            return this.kStrings.kNOTIFY_ME_BACK;
        },
        isValidEmail: function () {
            let email = this.form.email;
            // assuming email must have at least 5 characters (t@t.t)
            return email.length > 4 && emailRegExp.test(email);
        },
        showError: function () {
            // assuming email must have at least 5 characters (t@t.t)
            if (this.form.email.length < 5) {
                return false;
            }
            return !this.isValidEmail;
        },
    },
    methods: {
        kStringReplaceKey(kString, kOld, kNew) {
            return kString.replace(kOld, kNew);
        },
        closeFullPagePopup() {
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateShowPagePopup', '');
        },

        // submit form handler
        submit(e) {
            storePdp.dispatch('pdpDesktop/setLoading', true);
            if(!this.form.notificationSku) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateToastNotification', {
                    success: false,
                    message: this.kStrings.kSELECT_OPTION,
                    context: 'stock'
                });
                storePdp.dispatch('pdpDesktop/setLoading', false);
                return;
            }
            request.post(this.form.action, {
                sku: this.form.notificationSku,
                email: this.form.email,
                action: this.form.actionValue,
                isGroup: this.form.isGroup,
            }, false).then(response => {
                let data = response.data;

                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateToastNotification', {
                    success: !data.hasError,
                    message: data.message,
                    context: 'stock'
                });

                storePdp.dispatch('pdpDesktop/setLoading', false);
               /* if (!data.hasError) {
                    this.closeFullPagePopup();
                }*/
                // console.log(response.data);
                //currentObj.output = response.data;
            }).catch(error => {
                // console.log(error);
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateToastNotification', {
                    success: false,
                    message: this.kStrings.kGLOB_ERROR_MSG,
                    context: 'stock'
                });
                storePdp.dispatch('pdpDesktop/setLoading', false);
                //currentObj.output = error;
            });
            //this.validate("email", value);
        },

    },
    mounted() {
        //console.log(this.form);
    },
};
</script>

<style lang="scss">
@import "../styles/stockAlert";
</style>
